import { css } from '@emotion/react';

const customStyles = css`

`;

export const styles = [customStyles];
